const translation = {
  'url.about.accreditation': '/sobre-nosotros/certificacion',
  'url.about.graduates': '/cursos/egresados',
  'url.about.graduates-2': '/cursos/egresados-2',
  'url.about.graduates-3-with-popup': '/cursos/egresados-3-with-popup',
  'url.about.index': '/sobre-nosotros',
  'url.about.team': '/sobre-nosotros/equipo',
  'url.about.what-is-tefl-and-how-does-it-work': '/sobre-nosotros/lo-que-tefl-hace-y-como-funciona',
  'url.apply.how-to-make-a-good-application': '/apply/how-to-make-a-good-application',
  'url.apply.index': '/aplicar',
  'url.apply.terms': '/aplicar/terminos',
  'url.apply.thank-you': '/apply/thank-you',
  'url.birthday-competition-terms-conditions.index': '/birthday-competition-terms-conditions',
  'url.birthday-competition-terms-conditions.thank-you':
    '/birthday-competition-terms-conditions/thank-you',
  'url.brexit-guide.index': '/guia-brexit',
  'url.brexit-guide.thank-you': '/brexit-guide/thank-you',
  'url.clases-de-ingles-economicas-barcelona.evening':
    '/clases-de-ingles-economicas-barcelona/evening',
  'url.clases-de-ingles-economicas-barcelona.index': '/clases-de-ingles-economicas-barcelona',
  'url.contact.index': '/contacto',
  'url.contact.thank-you': '/contact/thank-you',
  'url.courses.dates.index': '/cursos/fechas',
  'url.courses.dates.special-offers': '/cursos/fechas/ofertas-especiales',
  'url.courses.one-month-160-hour-tefl-course.entry-requirements':
    '/cursos/4-semanas-160-horas-curso-tefl/requisitos-de-entrad',
  'url.courses.one-month-160-hour-tefl-course.index': '/cursos/4-semanas-160-horas-curso-tefl',
  'url.courses.developing-teacher-course': '/cursos/curso-desarollo-docente',
  'url.courses.tefl-work-and-placement': '/courses/tefl-work-and-placement',
  'url.courses.tefl-adventure': '/courses/tefl-adventure',
  'url.courses.tefl-spanish': '/courses/tefl-spanish',
  'url.teaching-kids-course': '/courses/teaching-kids-course',
  'url.courses.faq': '/cursos/preguntas-frecuentes',
  'url.courses.index': '/courses',
  'url.courses.online-trinity-certtesol-tefl-course':
    '/courses/online-trinity-certtesol-tefl-course',
  'url.courses.tefl-course-payment-plan': '/cursos/tefl-curso-plan-de-pagos',
  'url.es.apply.evening.index': '/es/apply/evening',
  'url.es.apply.evening.gracias': '/es/apply/evening/gracias',
  'url.es.apply.gracias': '/es/apply/gracias',
  'url.es.apply.index': '/es/apply/',
  'url.guide-to-teaching-english-online.index': '/guide-to-teaching-english-online',
  'url.guide-to-teaching-english-online.thank-you': '/guide-to-teaching-english-online/thank-you',
  'url.newsletter.thank-you': '/newsletter/thank-you',
  'url.spanish-visa-guide-australian-citizens.index': '/spanish-visa-guide-australian-citizens',
  'url.spanish-visa-guide-australian-citizens.thank-you':
    '/spanish-visa-guide-australian-citizens/thank-you',
  'url.spanish-visa-guide-canadian-citizens.index': '/spanish-visa-guide-canadian-citizens',
  'url.spanish-visa-guide-canadian-citizens.thank-you':
    '/spanish-visa-guide-canadian-citizens/thank-you',
  'url.spanish-visa-guide-uk-citizens.index': '/spanish-visa-guide-uk-citizens',
  'url.spanish-visa-guide-uk-citizens.thank-you': '/spanish-visa-guide-uk-citizens/thank-you',
  'url.spanish-visa-guide-us-citizens.index': '/spanish-visa-guide-us-citizens',
  'url.spanish-visa-guide-us-citizens.thank-you': '/spanish-visa-guide-us-citizens/thank-you',
  'url.spanish-visa-guide-south-african-citizens.index':
    '/spanish-visa-guide-south-african-citizens',
  'url.spanish-visa-guide-south-african-citizens.thank-you':
    '/spanish-visa-guide-south-african-citizens/thank-you',
  'url.tefl-iberia-brochure.index': '/tefl-iberia-brochure',
  'url.gap-year-brochure.index': '/gap-year-brochure',
  'url.gap-year-brochure.thank-you': '/gap-year-brochure/thank-you',
  'url.tefl-iberia-brochure.thank-you-guide': '/tefl-iberia-brochure/thank-you-guide',
  'url.tefl-iberia-brochure.thank-you': '/tefl-iberia-brochure/thank-you',
  'url.tefl-iberia-free-ebook.index': '/tefl-iberia-free-ebook',
  'url.tefl-iberia-free-ebook.thank-you': '/tefl-iberia-free-ebook/thank-you',
  'url.web.privacy': '/web/privacidad',
  'url.webinar.teaching-english-in-spain-after-brexit':
    '/webinar/teaching-english-in-spain-after-brexit',
  'url.webinar.tefl-coronavirus-everything-you-need-to-know':
    '/webinar/tefl-coronavirus-everything-you-need-to-know',
  'url.webinar.thank-you': 'webinar/thank-you',
  'url.working-as-a-teacher.careers-service': '/trabajando-como-profesor/servicios-al-estudiante',
  'url.working-as-a-teacher.student-visas': '/trabajando-como-profesor/visa-de-estudiante',
  'url.working-as-a-teacher.work-with-us': '/trabajando-como-profesor/trabaja-con-nosotros',
  'url.10th-birthday-course-giveaway': '/10th-birthday-course-giveaway',
  'url.accommodation': '/alojamiento',
  'url.application-recieved': '/application-recieved',
  'url.blended-trinity-cert-tesol-course': '/blended-trinity-cert-tesol-course',
  'url.blog': '/blog',
  'url.course-order': '/course-order',
  'url.covid': '/covid',
  'url.guide-to-living-and-teaching-english-in-barcelona':
    '/alojamiento/guia-para-trabajar-y-vivir-en-barcelona',
  'url.guide-to-living-and-teaching-english-in-seville':
    '/alojamiento/guia-para-trabajar-y-vivir-en-sevilla',
  'url.index': '/',
  'url.subscribe': '/subscribe',
  'url.teaching-kids-course': '/teaching-kids-course',
  'url.tefl-guide': '/tefl-guide',
  'url.tefl-spanish-course-barcelona': '/tefl-spanish-course-barcelona',
  'url.tefl-teaching-resources': '/recursos-tefl-iberia-para-enseñar',
  'url.thank-you': '/thank-you',
  'url.gap-year-program': '/gap-year-program',
};

module.exports = translation;
